<template>
  <div>
    <!-- 两个下拉 -->
    <template v-if="headerItem.dateAndTime">
      <el-popover
        placement="bottom-start"
        width="220"
        trigger="click"
        :ref="'popover' + headerIndex"
      >
        <template #reference>
          <div
            class="search-header hand"
            v-if="headerItem.type == 'InputSearch'"
          >
            <span class="search-title">{{ headerItem.label }}</span>
            &nbsp;<el-icon style="vertical-align: middle">
              <Search />
            </el-icon>
          </div>
          <div class="search-header hand" v-else>
            <span class="search-title">{{ headerItem.label }}</span>
            &nbsp;<el-icon style="vertical-align: middle">
              <ArrowDown />
            </el-icon>
          </div>
        </template>
        <el-select
          v-model="headerItem[headerItem.prop + 'Start']"
          placeholder="请选择"
          :filterable="
            headerItem.selectOptions && headerItem.selectOptions.length > 9
              ? true
              : false
          "
          :fit-input-width="true"
          size="large"
          @change="
            handleSearch(headerIndex, {
              name: 'option',
              prop: headerItem.prop,
              value: {
                start: headerItem[headerItem.prop + 'Start'],
                end: headerItem[headerItem.prop + 'End'],
              },
              source: headerItem.selectOptions,
              row: scope,
              type: 'select',
            })
          "
          clearable
        >
          <el-option
            v-for="item in headerItem.selectOptions && headerItem.selectOptions"
            :key="
              headerItem.cascaderValue
                ? headerItem.cascaderValue
                : item.key
                ? item.key
                : item.id
            "
            :label="
              headerItem.cascaderLabel
                ? headerItem.cascaderLabel
                : item.label
                ? item.label
                : item.name
                ? item.name
                : item.value
            "
            :value="item.key ? item.key : item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="headerItem[headerItem.prop + 'End']"
          placeholder="请选择"
          :filterable="
            headerItem.selectOptions1 && headerItem.selectOptions1.length > 9
              ? true
              : false
          "
          :fit-input-width="true"
          size="large"
          @change="
            handleSearch(headerIndex, {
              name: 'option',
              prop: headerItem.prop,
              value: {
                start: headerItem[headerItem.prop + 'Start'],
                end: headerItem[headerItem.prop + 'End'],
              },
              source: headerItem.selectOptions1,
              row: scope,
              type: 'select',
            })
          "
          clearable
        >
          <el-option
            v-for="item in headerItem.selectOptions1 &&
            headerItem.selectOptions1"
            :key="item.key ? item.key : item.id"
            :label="
              item.label ? item.label : item.name ? item.name : item.value
            "
            :value="item.key ? item.key : item.id"
          >
          </el-option>
        </el-select>
      </el-popover>
    </template>
    <!-- 多选 -->
    <el-popover
      v-else-if="headerItem.multiple && headerItem.multiple"
      placement="bottom-start"
      width="220"
      trigger="click"
      :ref="'popover' + headerIndex"
    >
      <template #reference>
        <div class="search-header hand" v-if="headerItem.type == 'InputSearch'">
          <span class="search-title">{{ headerItem.label }}</span>
          &nbsp;<el-icon style="vertical-align: middle">
            <Search />
          </el-icon>
        </div>
        <div class="search-header hand" v-else>
          <span class="search-title">{{ headerItem.label }}</span>
          &nbsp;<el-icon style="vertical-align: middle">
            <ArrowDown />
          </el-icon>
        </div>
      </template>
      <el-select
        v-model="headerItem[headerItem.prop]"
        placeholder="请选择"
        multiple
        :filterable="
          headerItem.selectOptions && headerItem.selectOptions.length > 9
            ? true
            : false
        "
        size="large"
        no-data-text="暂无数据"
        @change="
          handleSearch(headerIndex, {
            name: 'option',
            prop: headerItem.prop,
            value: headerItem[headerItem.prop],
            source: headerItem.selectOptions,
            row: scope,
            type: 'selectAll',
          })
        "
        clearable
      >
        <el-checkbox
          class="right checkbox"
          v-model="checked"
          @change="selectAll(headerItem.prop, headerIndex)"
          >全选
        </el-checkbox>
        <el-option
          v-for="item in headerItem.selectOptions && headerItem.selectOptions"
          :key="item.key ? item.key : item.id"
          :label="
            item.label
              ? item.label
              : item.name
              ? item.name
              : item.value
              ? item.value
              : item.Value
          "
          :value="item.key ? item.key : item.id"
        >
        </el-option>
      </el-select>
    </el-popover>
    <!-- 非多选 -->
    <el-select
      v-else
      v-model="headerItem[headerItem.prop]"
      :placeholder="headerItem.label+'(全部)'"
      :filterable="
        headerItem.selectOptions && headerItem.selectOptions.length > 9
          ? true
          : false
      "
      :class="headerItem.zwidth?`width-${headerItem.zwidth}`:''"
      :fit-input-width="true"
      size="large"
      @change="
        handleSearch(headerIndex, {
          name: 'option',
          prop: headerItem.prop,
          value: headerItem[headerItem.prop],
          source: headerItem.selectOptions,
          row: scope,
          type: 'select',
        })
      "
      clearable
    >
      <el-option
        v-for="item in headerItem.selectOptions && headerItem.selectOptions"
        :key="
          headerItem.cascaderValue != null || headerItem.cascaderValue != undefined
            ? item[headerItem.cascaderValue]
            :item.key != null || item.key != undefined
            ? item.key
            : item.id
        "
        :label="
          headerItem.cascaderLabel != null || headerItem.cascaderLabel != undefined
            ? item[headerItem.cascaderLabel]
            : item.label != null || item.label != undefined
            ? item.label
            : item.name != null || item.name != undefined
            ? item.name
            : item.value
        "
        :value="
          headerItem.cascaderValue != null || headerItem.cascaderValue != undefined
            ? item[headerItem.cascaderValue]
            : item.key != null || item.key != undefined
            ? item.key
            : item.id
        "
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox } from "element-plus";
import { ref, reactive, toRefs } from "vue";
export default {
  props: {
    headerItem: Object,
    headerIndex: Number,
    key: Number,
    scope: Object,
    height: Number,
  },
  setup(props, { emit }) {
    const data = reactive({
      checked: false,
    });
    const handleSearch = (index, option) => {
      console.log(option, "传入参数");
      if (option.type == "selectAll") {
        // 选中的组件为全部组件的时候下拉框中的全选框得为选中状态
        if (option.value.length == option.source.length) {
          data.checked = true;
        } else {
          data.checked = false;
        }
      }
      emit("searchFnc", option);
    };
   
    // 下拉搜索框多选全选
    const selectAll = (val, index) => {
      console.log(val, data.checked, 111);
      props.headerItem[props.headerItem.prop] = [];
      if (data.checked) {
        props.headerItem.selectOptions.map((item1) => {
          props.headerItem[props.headerItem.prop].push(item1.key || item1.id);
        });
        console.log(props.headerItem[props.headerItem.prop], 3332211);
        handleSearch(index, {
          name: "option",
          prop: val,
          value: props.headerItem[props.headerItem.prop],
          source: props.headerItem.selectOptions,
          row: "",
          type: "select",
        });
      } else {
        props.headerItem[props.headerItem.prop] = [];
        handleSearch(index, {
          name: "option",
          prop: val,
          value: [],
          source: props.headerItem.selectOptions,
          row: "",
          type: "select",
        });
      }
    };
    const refData = toRefs(data);
    return {
      handleSearch,
      selectAll,
      ...refData,
    };
  },
};
</script>

<style lang="scss" scoped>
@for $i from 0 through 1000 {
		.width-#{$i} {
			width: #{$i}px;
		}
}
</style>
<style scoped >
.el-checkbox {
  text-align: right;
  width: 100%;
  padding-right: 10px;
}
/* .width-250{
  width: 250px;
} */
.el-input--suffix >>> .el-input__inner {
  padding-right: 55px;
}

.checkbox {
  border-bottom: 1px solid rgba(245, 245, 245, 0.7);
  padding-bottom: 5px;
  line-height: 20px;
  justify-content: right;
}

.trends_btn_wrap .el-checkbox-group label {
  width: auto;
  margin: 0 !important;
  margin: 0 10px !important;
  margin-bottom: 10px !important;
}

.trends_btn_wrap .table_container .el-table .cell {
  text-overflow: initial !important;
}

.trends_btn_wrap */deep/.el-checkbox-group label {
  margin: 0 5px !important;
  margin-bottom: 10px !important;
  margin-right: 0 !important;
}

.el-checkbox.is-bordered.el-checkbox--small {
  padding: 5px 10px 5px 10px;
  border-radius: 3px;
  height: 32px;
  /* width: 110px; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 10px !important;
  margin-right: 0 !important;
}

.el-checkbox.is-bordered.el-checkbox--small .el-checkbox__label {
  /* width: 75px; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

*/deep/.el-dialog {
  -webkit-backface-visibility: hidden;
}

.el-select >>> .el-input__suffix {
  display: inline-flex;
}
</style>
